import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function LawsPage() {
    const [lawGovernmentServicesArray, setLawGovernmentServicesArray] = useState<Service[]>([]);
    const [lawEuropeanServicesArray, setLawEuropeanServicesArray] = useState<Service[]>([]);
    const [lawIndependentsServicesArray, setlawIndependentsServicesArray] = useState<Service[]>([]);
    const [lawInstitutionServicesArray, setLawInstitutionServicesArray] = useState<Service[]>([]);

    const getLawGovernmentServices = (): Array<Service> =>
        servicesData.filter((srv: Service) => srv.category === "ΝομοΚυβερνητικοί Οργανισμοί");

    const getLawEuropeanServices = (): Array<Service> =>
        servicesData.filter((srv: Service) => srv.category === "ΝομοΕυρωπαϊκοί Οργανισμοί");

    const getLawInstitutionServices = (): Array<Service> =>
        servicesData.filter((srv: Service) => srv.category === "ΝομοΙδρύματα - Οργανισμοί");

    const getLawIndependents = (): Array<Service> =>
        servicesData.filter((srv: Service) => srv.category === "ΝομοΑνεξάρτητες Αρχές");

    useEffect(() => {
        const governmentServicesList = getLawGovernmentServices();
        setLawGovernmentServicesArray(governmentServicesList);
    }, []);

    useEffect(() => {
        const europeanServicesList = getLawEuropeanServices();
        setLawEuropeanServicesArray(europeanServicesList);
    }, []);

    useEffect(() => {
        const institutionServicesList = getLawInstitutionServices();
        setLawInstitutionServicesArray(institutionServicesList);
    }, []);

    useEffect(() => {
        const independentsList = getLawIndependents();
        setlawIndependentsServicesArray(independentsList);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={useColorModeValue("primary", "light")}>
                <TabList flex="1">
                    <Tab style={{ fontWeight: 'bold' }}>Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ιδρύματα - Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ανεξάρτητες Αρχές</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {lawGovernmentServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {lawEuropeanServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {lawInstitutionServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {lawIndependentsServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
